import React, { Component } from 'react';
import { Box } from '@material-ui/core';
import { connect } from 'react-redux';
import { DUNS_NOT_USED_FLG } from '../../../common/const';
import styles from './CompanySelectedComponent.module.css';

class CompanySelectedComponent extends Component {
  render() {
    const {
      selectedCompanyInfo,
      userInfo,
    } = this.props;
    const SPACE = '　';
    return (
      <div>
        {
          userInfo.duns_not_used_flag === DUNS_NOT_USED_FLG.ON ? (
            <Box className={`${styles.title}`}>
              {selectedCompanyInfo.kigyo_code
                ? `${selectedCompanyInfo.kigyo_code
                }${SPACE}`
                : ''}
              <Box className={`${styles.companyname}`}>
                {selectedCompanyInfo.trade_name || ''}
              </Box>
            </Box>
          ) : (
            <Box className={`${styles.title}`}>
              {selectedCompanyInfo.duns
                ? `D-U-N-S：${selectedCompanyInfo.duns.substr(0, 2)
                }-${selectedCompanyInfo.duns.substr(2, 3)
                }-${selectedCompanyInfo.duns.substr(5, 4)}${SPACE}`
                : ''}
              <Box className={`${styles.companyname}`}>
                {selectedCompanyInfo.trade_name || ''}
              </Box>
            </Box>
          )
        }
      </div>
    );
  }
}

export default connect(
  (state) => ({
    // 選択中企業情報
    selectedCompanyInfo: state.company.selectedCompanyInfo,
    // ユーザー情報
    userInfo: state.common.userInfo,
  }),
  null,
)(CompanySelectedComponent);
